<template>
  <div id="app">    
    <the-header></the-header>
    <div class="content" >
      <router-view></router-view>
    </div>
    <the-footer></the-footer>
  </div>
</template>

<script>
import TheHeader from './components/layout/TheHeader'
import TheFooter from './components/layout/TheFooter'
import 'particles.js'

export default {
  name: 'app',
  components: {
    TheHeader,
    TheFooter  
  } ,
 
}
</script>

<style>

body {
  font-family: 'Montserrat';
  font-weight:300;
  padding: 0;
  margin:0;
}

.content  {
  width:100%;
  max-width: 100%;
}

a {
  text-decoration: none;
}

/* @group Montserrat
-------------------------------------------------------------- */

/* = Weights Montserrat  
-------------------------------------------------------------- */

.thin {
	/* Montserrat Thin = 100 */
	font-weight: 100;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}

.extralight {
	/* Montserrat Extra Light = 200 */
	font-weight: 200;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}


.light {
	/* Montserrat Light = 300 */
	font-weight: 300;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}


.regular {
	/* Montserrat Regular = 400 */
	font-weight: 400;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}


.medium {
	/* Montserrat Medium = 500 */
	font-weight: 500;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}


.semibold {
	/* Montserrat Semi-bold = 600 */
	font-weight: 600;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}


.bold {
	/* Montserrat Bold = 700 */
	font-weight: 700;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}


.extrabold {
	/* Montserrat Extra Bold = 800 */
	font-weight: 800;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}


.black {
	/* Montserrat Black = 900 */
	font-weight: 900;
	font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}

/* @end Montserrat group */

.btn-main {
  background: linear-gradient(to right, #ef4337,#fbab37);
  color: #ffffff;
  margin-top:20px;
  padding:10px 50px 10px 15px;
  border-radius:15px;
  /* border:1px solid #ffffff; */
  font-size:12px;
  cursor: pointer;
  text-transform: uppercase;
  position:relative;
  text-decoration:none;
  transition:0.5s;
}

.btn-main:hover {
  background: linear-gradient(to right, #ef4337,#ef4337);
}

.btn-main:after {
  content:url('./assets/arrow-btn.png');
  position: absolute;
  right: 10px;
  top: 12px;
}

.btn-second {
  background: #fbab37;
  color: #ffffff;
  margin-top:20px;
  padding:10px 25px;
  border-radius:15px;
  font-size:12px;
  cursor: pointer;
  transition:0.5s;
}

.btn-second:hover {
  background:#ef4337;
}

.bg-menu {
  position:absolute;
  top:0;
  right:0;
  left:0;
  height:100px;
  background:url('./assets/bg-menu.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}


  /* burger */

  .s3d-menu .bm-burger-button {
    position: absolute;
    width: 26px;
    height: 20px;
    left: 20px;
    top: 35px;
    cursor: pointer;
  }

  .s3d-menu .bm-burger-bars {
    background-color: #fff;
  }

  .s3d-menu .cross-style {
    position: absolute;
    top: 20px;
    right: 200px !important;
    cursor: pointer;
  }

  .s3d-menu .bm-cross {
    background: #fff;
  }

  .s3d-menu .bm-cross-button {
    height: 30px;
    width: 30px;
  }

  .s3d-menu .bm-menu {
    background: rgb(26,26,35);

  }

  .tooltip-display {
    background:#fff;
    margin-left:10px;
    border-radius:5px;
    padding:20px;
     z-index: 1;
     -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
    max-width:600px;
    width:90%;

  }

  /* .tooltip-arrow {
    width:0;
    height:0;
    position: absolute;
    border-style: solid;
    border-width: 10px 10px 10px 0;
    border-color: transparent #fff transparent transparent;
    left: -5px;
    z-index:1;
    top: calc(50% - 5px);
    margin-left: -5px;
    margin-right: 0;

  } */





  @media screen and (max-width:767px) {


    .portfolio-box  {
      margin:0 !important;
    }

    .portfolio-box h2 {
      margin:40px 0;
    }

    .section-last.portfolio-box {
      padding-bottom:0 !important;
    }


  }

  @media screen and (max-width:1260px) {
        .bg-menu {
      height:90px;
    }
  }

</style>
